<template>
    <ui-link class="ui-inline-nft" v-bind:to="routerParams" v-bind:class="{'ui-inline-nft--green': !isOut}">
        <div class="ui-inline-nft__left">
            <div class="ui-inline-nft-image">
                <img class="ui-inline-nft-image__img" v-bind:src="imageSrc" v-show="!hasError" v-on:error="hasError = true" alt="">
                <icon-nft class="ui-inline-nft-image__svg"/>
            </div>
        </div>
        <div v-if="eventType && nftName" class="ui-inline-nft__title">
            <p>{{ getNftName }}</p>
            <p v-if="isMobile" v-bind:class="isMobile && !isOut ? 'ui-inline-nft__collection--green' : 'ui-inline-nft__collection'">
                <span v-if="collectionName">{{ collectionName }}</span>
                <span v-else>{{ $t('address.nfts.single_nft') }}</span>
            </p>
        </div>
        <div v-else class="ui-inline-nft__title">
            <p>{{ $t('common.nft_item') }}</p>
            <p v-if="isMobile" v-bind:class="isMobile && !isOut ? 'ui-inline-nft__collection--green' : 'ui-inline-nft__collection'">
                <span v-if="collectionName">{{ collectionName }}</span>
                <span v-else>{{ $t('address.nfts.single_nft') }}</span>
            </p>
        </div>
    </ui-link>
</template>

<script>
import IconNft from '@img/icons/tonscan/nft-14.svg?inline';

export default {
    props: {
        address: String,
        eventType: String,
        imageSrc: String,
        nftName: String,
        collectionName: String,
        collectionAddress: String,
        isOut: Boolean,
    },

    data() {
        return {
            hasError: false,
        };
    },

    mounted() {
        if (!this.imageSrc) this.hasError = true;
    },

    computed: {
        getNftName() {
            if (this.nftName.length > 22) {
                return this.nftName.substring(0, 10) + '...' + this.nftName.substring(this.nftName.length - 10);
            }
            return this.nftName;
        },
        routerParams() {
            return {
                name: 'nft',
                params: {
                    address: this.address,
                    skeletonHint: 'item',
                },
            };
        },
    },

    components: {
        IconNft,
    },
};
</script>

<style lang="scss">
.ui-inline-nft {
    display: flex;
    align-items: center;
    background: var(--nft-preview-background);
    border-radius: 6px;
    margin: -4px 0;
    color: inherit;
    transition: .2s;

    &__left {
        width: 26px;
        height: 26px;
    }
    &__title {
        padding: 5px 10px;
        font-size: 13px;
        font-weight: 600;
        p {
            margin: 0;
            padding: 0;
        }
    }
    &__collection {
        margin: 0;
        font-size: 12px;
        color: var(--body-muted-text-color);
    }
    &--green {
        color: var(--green-bright);
        background-color: var(--tx-table-icon-in-background);
        .ui-inline-nft-image {
            color: var(--green-bright);
            border-radius: 6px !important;
        }
        &:hover {
            background-color: var(--tx-table-icon-in-hover-background) !important;
            color: var(--green-bright) !important;
            .ui-inline-nft-image {
                color: var(--green-bright);
            }
        }
    }
    &:hover {
        background: var(--icon-button-hover-background);
        color: inherit;
        text-decoration: none;

        .ui-inline-nft-image {
            color: inherit;
        }
    }
}

@media screen and (max-width: 600px) {
    .ui-inline-nft{
        display: inline-flex;
        border-radius: 8px!important;
        padding: 0!important;
        margin: 8px 0 0 0!important;

        &__title {
            padding-right: 14px!important;
        }

        &__left {
            width: 52px;
            height: 52px;
        }
        &__collection--green {
            color: var(--green-bright);
            opacity: .6;
        }
        &--green {
            color: var(--green-bright);
            background-color: var(--tx-table-icon-in-background);
            border-radius: 8px !important;
            .ui-inline-nft-image {
                color: var(--green-bright);
                border-radius: 8px !important;
            }
            &:hover {
                opacity: .9;
                background-color: var(--tx-table-icon-in-background)!important;
                color: var(--green-bright)!important;
                .ui-inline-nft-image {
                    color: var(--green-bright);
                }
            }
        }
        &:hover:not(.ui-inline-nft--green) {
            opacity: .9;
            background: var(--nft-preview-background);
            color: inherit;
            .ui-inline-nft-image {
                color: inherit;
            }
        }
    }

    .ui-inline-nft-image__svg {
        width: 20px!important;
        height: 20px!important;
    }

    .ui-inline-nft-image__img {
        border-radius: 7px!important;
    }
}

.ui-inline-nft-image {
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    margin: 1px 0 0 1px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--body-text-color);
    &__img {
        object-fit: cover;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1000;
        border-radius: 5px;
    }
    &__svg {
        width: 14px;
        height: 14px;
        opacity: 0.8;
        z-index: 100;
    }
}
</style>
